export default "__VITE_ASSET__CoOQ5o$___"